/*
 * Package Import
 */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

/*
 * Local import
 */
import { openChat, changeMainChatView } from 'src/store/actions';
import UserCard from './index';

/*
 * Code
 */
const mapStateToProps = (state, ownProps) => ({
  mugshot: state.users.mugshotById[ownProps?.user?.id],
});

// Actions
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      openChat,
      changeMainChatView,
    },
    dispatch,
  ),
});

/*
 * Export
 */
export default connect(mapStateToProps, mapDispatchToProps)(UserCard);
